import React__default from 'react';
import Badge from '../Badge.js';
import { BULK_LOAD_CARD_STATUS_TEXT } from '../../../constants/bulkLoadCardStatus.js';
import { BadgeTypes } from '../../../constants/misc.js';

const BulkLoadBadgeController = ({ status, badgeClass }) => {
    const renderBadge = () => {
        switch (status) {
            case BULK_LOAD_CARD_STATUS_TEXT.PUBLISHED:
                return (React__default.createElement(Badge, { type: BadgeTypes.PUBLISHED, text: BULK_LOAD_CARD_STATUS_TEXT.PUBLISHED, badgeClass: badgeClass, squaredEdges: true }));
            case BULK_LOAD_CARD_STATUS_TEXT.UNDER_REVIEW:
                return (React__default.createElement(Badge, { type: BadgeTypes.PROGRESS, text: BULK_LOAD_CARD_STATUS_TEXT.UNDER_REVIEW, badgeClass: badgeClass, squaredEdges: true }));
            case BULK_LOAD_CARD_STATUS_TEXT.FULFILLED:
                return (React__default.createElement(Badge, { type: BadgeTypes.COMPLETED, text: BULK_LOAD_CARD_STATUS_TEXT.FULFILLED, badgeClass: badgeClass, squaredEdges: true }));
            case BULK_LOAD_CARD_STATUS_TEXT.PARTIAL_FULFILLED:
                return (React__default.createElement(Badge, { type: BadgeTypes.COMPLETED, text: BULK_LOAD_CARD_STATUS_TEXT.PARTIAL_FULFILLED, badgeClass: badgeClass, squaredEdges: true }));
            case BULK_LOAD_CARD_STATUS_TEXT.EXPIRED:
            default:
                return (React__default.createElement(Badge, { type: BadgeTypes.DEFAULT, text: BULK_LOAD_CARD_STATUS_TEXT.EXPIRED, badgeClass: badgeClass, squaredEdges: true }));
        }
    };
    return renderBadge();
};

export { BulkLoadBadgeController as default };
//# sourceMappingURL=BulkLoadBadgeController.js.map
